<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">Cambiar Password</span></h3>
          </v-card-title>
          <v-card-text>

                <v-flex xs12>
                  <v-text-field
                    ref="password"
                    prepend-icon="password"
                    v-model="form.password"
                    :rules="[v => !!v || 'Password es requerido',v => (v && v.length >= 8) || 'Password debe contener minimo 8+ caracteres']"
                    required
                  ></v-text-field>
                </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" class="primary" @click="submitFormAgremiado">Cambiar Password</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
  name: 'form-user-view',

  props: {
    agremiado: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  watch: {
    agremiado(v) {
      this.$refs.form.resetValidation()
      this.form.user_id = ''
      this.form.password = ''
    }
  },

  computed: {
    ...mapGetters({
      authenticated: 'authCheck'
    }),
  },

  data: () => ({
    valid: false,
    form: new Form({
      user_id: '',
      password: '',
    })
  }),

  methods: {

    async submitFormAgremiado () {
      this.form.user_id = this.agremiado.user_id;
      if (this.$refs.form.validate()) {
        this.$emit('loadingResponse', true)
        try {
          let formData = new FormData();
          for (var key in this.form) {
            formData.append(key, this.form[key]);
          }
          const { data } = await axios.post('/api/users/admin/changue_password_agremiado', formData)
          this.cerrarDialog(data)
        } catch (e) {
          console.log(e.response)
          this.$emit('loadingResponse', false)
        }
      }
    },

    cerrarDialog (data) {
      this.$emit('closeDialogChanguePassworUser', data)
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
        this.$emit('loadingResponse', false)
     })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/formChanguePassword.vue